const RATINGS_STATE_TTL_MS = 30 * 1000;

type IStoredValue<T> = {
  expiresAt: number;
  value: T;
};

export const getPersistedRatingsState = <T,>(key: string, fallback: T): T => {
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return fallback;

    const parsed = JSON.parse(raw) as IStoredValue<T>;
    if (!parsed?.expiresAt || Date.now() > parsed.expiresAt) {
      sessionStorage.removeItem(key);
      return fallback;
    }

    return parsed.value;
  } catch {
    return fallback;
  }
};

export const setPersistedRatingsState = <T,>(key: string, value: T): void => {
  try {
    const payload: IStoredValue<T> = {
      expiresAt: Date.now() + RATINGS_STATE_TTL_MS,
      value,
    };

    sessionStorage.setItem(key, JSON.stringify(payload));
  } catch {}
};
